import { Checkbox, FormControlLabel } from "@mui/material";
import { useController, useFormContext } from "react-hook-form";
import { useConditional } from "../FormDefinitionRenderer/useConditional.js";
import { useFormEditMode } from "../FormDefinitionRenderer/contexts.js";

export default function CheckboxControl({ item }) {
  const { control } = useFormContext();
  const { field } = useController({
    control,
    name: item.name,
    defaultValue: false,
  });
  const isDisabled = useConditional(item.disabled) || !useFormEditMode();

  return (
    <FormControlLabel
      label={item.label}
      control={
        <Checkbox {...field} checked={!!field.value} disabled={isDisabled} />
      }
    />
  );
}
